import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { actionCreators } from '../store/Login';
import { bindActionCreators } from 'redux';
import { UserRoles, EditState } from '../components/shared/enums';
import { toast } from 'react-toastify';
import './Home/Home.css';

class SupportTeam extends Component {
    displayName = SupportTeam.name;

    constructor(props) {
        super(props);
        this.showEditButton = this.props.isAuthenticated && this.props.isEditHome &&
            (this.props.userRole === UserRoles.Administrator || this.props.userRole === UserRoles.SalesRep);

        this.state = {
            originalItems: [],
            items: [],
            editMode: EditState.List
        };
    }

    componentDidMount = async () => {
        const fetchConfig = {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        };

        const response = await fetch('api/Home/supportcontacts/', fetchConfig);
        if (response.ok) {
            let data = await response.json();
            // We insist on 3 Support Team items
            for (var i = data.length; i < 3; i++) {
                data.push({
                    index: i,
                    name: "",
                    direct: "",
                    main: "",
                    mobile: "",
                    email: ""
                });
            }
            this.setState({ items: data });
        }
        else if (response.status === 401) {
            // Depending on from where this is called, signOut might not be available
            if (this.props.signOut)
                this.props.signOut();
        }
        else {
            var err = await response.text();
            console.log(`Failed to load Support Team: ${err}.`);
            toast.error("Failed to load Support Team.");
        }
    }

    onClickEdit = (e) => {
        const deepCopy = this.state.items.map(a => Object.assign({}, a));
        this.setState({ editMode: EditState.Edit, originalItems: deepCopy });
    }

    onClickCancel = (e) => {
        this.setState({ editMode: EditState.List, items: this.state.originalItems });
        this.props.setDirty(false);
    }

    onClickSubmit = async () => {
        var data = this.state.items;

        const fetchConfig = {
            method: 'PUT',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`,
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify(data)
        };

        const response = await fetch('api/home/supportcontacts/', fetchConfig);
        if (response.ok) {
            toast.success("Support Contacts updated.");
            this.setState({ editMode: EditState.List });
            this.props.setDirty(false);
        }
        else if (response.status === 401) {
            toast.error("Unauthorized.");
            this.props.signOut();
        }
        else {
            toast.error(`Error saving Support Contacts.`);
            console.log(`Error saving Support Contacts: ${await response.text()}.`);
        }
    }

    onChange = (supportItems, field) => (evt) => {
        const si = supportItems;

        switch (field) {
            case "fullName":
                si.name = evt.target.value;
                this.setState({ si });
                break;
            case "directNumber":
                si.direct = evt.target.value;
                this.setState({ si });
                break;
            case "mainNumber":
                si.main = evt.target.value;
                this.setState({ si });
                break;
            case "cellNumber":
                si.mobile = evt.target.value;
                this.setState({ si });
                break;
            case "email":
                si.email = evt.target.value;
                this.setState({ si });
                break;
            default:
                break;
        }
        this.props.setDirty(true);
    }

    render() {
        return (
            <div>
                <div className="support-team">
                    <div className="support-team-heading" >
                        Brought to you by the OGC Support Team
                        <div className='pull-right'>
                            {this.showEditButton && this.state.editMode === EditState.List &&
                                <button className="ogcButton btn-std-size" onClick={this.onClickEdit}>Edit</button>
                            }
                            {this.showEditButton && this.state.editMode === EditState.Edit &&
                                <React.Fragment>
                                    <button className={(this.props.isDirty) ? "ogcButton btn-std-size" : "ogcDisabledButton btn-std-size"} onClick={this.onClickSubmit} disabled={!this.props.isDirty}>Submit</button>
                                    <button className="ogcButton ogcButton-brown btn-std-size" style={{ border: '1px solid white' }} onClick={this.onClickCancel}>Cancel</button>
                                </React.Fragment>
                            }
                        </div>
                    </div>
                    <div>
                        {this.state.items.map((item, idx) => (
                            <div key={idx} className="support-team-item" >
                                <table className="supportTeamTable">
                                    {this.state.editMode === EditState.List &&
                                        <tbody>
                                            {item.name.length > 0 &&
                                                <React.Fragment>
                                                    <tr className="support-team-name" >
                                                        <td style={{ textAlign: 'right' }}>Name:</td>
                                                        <td><span>{item.name}</span></td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ textAlign: 'right' }}>Direct:</td>
                                                        <td><span>{item.direct}</span></td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ textAlign: 'right' }}>Main:</td>
                                                        <td><span>{item.main}</span></td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ textAlign: 'right' }}>Cell:</td>
                                                        <td><span>{item.mobile}</span></td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ textAlign: 'right' }}>Email:</td>
                                                        <td><span style={{ textDecoration: 'underline' }}>{item.email}</span></td>
                                                    </tr>
                                                </React.Fragment>}
                                        </tbody>
                                    }
                                    {this.state.editMode === EditState.Edit &&
                                        <tbody>
                                            <tr className="support-team-name" >
                                                <td style={{ textAlign: 'right' }}>Name:</td>
                                                <td><span style={{ fontWeight: 'bold' }}><input className="supportTeamInput" onChange={this.onChange(item, 'fullName')} value={item.name} /></span></td>
                                            </tr>
                                            <tr>
                                                <td style={{ textAlign: 'right' }}>Direct:</td>
                                                <td><span><input className="supportTeamInput" onChange={this.onChange(item, 'directNumber')} value={item.direct} /></span></td>
                                            </tr>
                                            <tr>
                                                <td style={{ textAlign: 'right' }}>Main:</td>
                                                <td><span><input className="supportTeamInput" onChange={this.onChange(item, 'mainNumber')} value={item.main} /></span></td>
                                            </tr>
                                            <tr>
                                                <td style={{ textAlign: 'right' }}>Cell:</td>
                                                <td><span><input className="supportTeamInput" onChange={this.onChange(item, 'cellNumber')} value={item.mobile} /></span></td>
                                            </tr>
                                            <tr>
                                                <td style={{ textAlign: 'right' }}>Email:</td>
                                                <td><span style={{ textDecoration: 'underline' }}><input className="supportTeamInput" onChange={this.onChange(item, 'email')} value={item.email} /></span></td>
                                            </tr>
                                        </tbody>
                                    }
                                </table>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(connect(state => state.login,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(SupportTeam));


// WEBPACK FOOTER //
// ./src/components/SupportTeam.js